import { render, staticRenderFns } from "./Formularioqrcita.vue?vue&type=template&id=547639fa"
import script from "./Formularioqrcita.vue?vue&type=script&lang=js"
export * from "./Formularioqrcita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports